module.exports = __webpack_public_path__ + "img/icons-timer_white.a6b7ea39.svg";